<template>
  <div v-if="!patientIdentifier" data-private >
    <PatientSearch />
  </div>
  <div v-else data-private>
    <Overview_Patient :patient-identifier="patientIdentifier"/>
  </div>

</template>

<script>



import PatientSearch from "@/components/widgetcomponents/Search_Widgets/Patient_Search.vue";
import Overview_Patient from "@/components/Overview/Overview_Patient.vue";

export default {
  components: {Overview_Patient, PatientSearch},
  props:{
    patientIdentifier:{
      type: String,
      default: null
    }
  },
  data() {
  },
  computed:{

  },
  mounted() {
    console.log(this.patientIdentifier)
  },
  methods:{
  },
}
</script>
